<template>
  <div class="page">
    <Header
      :setting="{
        title: '超音波影像',
        hasCancelMethod: true,
      }"
      @cancel="$emit('cancel')"
      class="mb4"
    />
    <div class="border-radius-1 mb4">
      <img
        v-if="image.type==='photo'"
        :src="image.url"
        alt=""
        class="border-radius-1"
      >
      <video
        v-else
        controls
        autoplay
        loop
        muted
        playsinline
        class="border-radius-1"
      >
        <source
          :src="image.url"
          type="video/mp4"
        >
        Your browser does not support this video file.
      </video>
    </div>
    <div class="row--evenly mt3">
      <div
        @click="$emit('shareImage',image)"
        class="label label--primary pv2 row--central mh4"
      >
        <font-awesome-icon :icon="['fas', 'share']" />
        <div class="ml2">
          下載 & 分享
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['shareImage', 'cancel'],
};
</script>
